// Modification : Zacharie Nolet
// Date de modification : 2026-04-09
// Commit : 0bc0802 - Modification acceuil
import TopCollectors from "../../Dashboard/Tops_score/TopCollectors";
import TopByCategory from "../../Dashboard/Tops_score/TopByCategory";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function TeacherHomePanel({ user }) {
  const navigate = useNavigate();

  return (
    <div className="home-dashboard">
      {/* Header simple */}
      <div className="home-welcome-block">
        <h3>Bienvenue {user?.first_name || "Enseignant"}</h3>
      </div>

      {/* Actions rapides */}
      <div className="home-dashboard-grid">
        <div className="home-dashboard-card">
          <h4>Badges</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate("/admin/badges")}
            >
              Gérer les badges
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Catégories</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/admin/categories")}
            >
              Voir les catégories
            </Button>
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Utilisateurs</h4>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => navigate("/admin/users")}
            >
              Voir les utilisateurs
            </Button>
          </Box>
        </div>
      </div>

      {/* Stats */}
      <Box sx={{ mt: 5 }}>
        <Typography variant="h5" gutterBottom>
          Statistiques
        </Typography>
      </Box>

      <div className="home-dashboard-grid">
        <div className="home-dashboard-card">
          <h4>Top collectionneurs</h4>
          <Box sx={{ mt: 2 }}>
            <TopCollectors />
          </Box>
        </div>

        <div className="home-dashboard-card">
          <h4>Top par catégorie</h4>
          <Box sx={{ mt: 2 }}>
            <TopByCategory />
          </Box>
        </div>
      </div>
    </div>
  );
}